import { HashtagIcon } from '@heroicons/react/24/solid';
import Badge from '../Styled/Badge';

export default function PhotoHashBadge({ hasHash }: { hasHash?: boolean | null }) {
  if (!hasHash) return null;
  return (
    <Badge $solid title="SHA-256 hash stored" aria-label="SHA-256 hash stored">
      <HashtagIcon aria-hidden="true" />
      SHA-256
    </Badge>
  );
}
